<template>
  <label>
    <input
      type="checkbox"
      :checked="checked"
      :indeterminate.prop="indeterminate"
      @click="$emit('toggle')">
  </label>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    }
  }
}
</script>
